"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noZones = void 0;
var noZones = exports.noZones = [{
  id: 'OSLO',
  name: 'Oslo',
  country: 'NO',
  cornerNW: {
    latitude: 60.0499,
    longitude: 10.3832
  },
  cornerSE: {
    latitude: 59.8037,
    longitude: 10.9519
  },
  subZones: [{
    name: 'Oslo Centre historique',
    zipcodes: {
      '0010': {
        label: '0010'
      }
    }
  }, {
    name: 'Oslo Sentrum',
    zipcodes: {
      '0150': {
        label: '0150'
      }
    }
  }, {
    name: 'Oslo Majorstuen',
    zipcodes: {
      '0250': {
        label: '0250'
      }
    }
  }, {
    name: 'Oslo Nordre Aker',
    zipcodes: {
      '0350': {
        label: '0350'
      }
    }
  }, {
    name: 'Oslo Bygdøy',
    zipcodes: {
      '0530': {
        label: '0530'
      }
    }
  }, {
    name: 'Oslo Frogner',
    zipcodes: {
      '0550': {
        label: '0550'
      }
    }
  }, {
    name: 'Oslo Grünerløkka',
    zipcodes: {
      '0650': {
        label: '0650'
      }
    }
  }, {
    name: 'Oslo Gamlebyen',
    zipcodes: {
      '0770': {
        label: '0770'
      }
    }
  }, {
    name: 'Oslo Ransbekk',
    zipcodes: {
      '0980': {
        label: '0980'
      }
    }
  }]
}];